import axios from "axios";
import { getCookie } from "../utils/cookies";
import { AlertError } from "../utils/componentes-utiles/AlertError";


const baseUrl = 'https://www.gestoriajgarcia.com/test/WS/'
const ticketsBaseUrl = 'https://www.jcinformatics.es/tessatickets/'


//////////////////////////////tessa ticketes//////////////////////////////////////////////////////

export const postTegistrarTicket = async (data, archivo) => {
    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON

        formData.append('file[]', archivo);
        const response = await axios.post(ticketsBaseUrl + 'ticketSign.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};

//////////////////////////////tessa management//////////////////////////////////////////////////////
//gets
export const getopcinesMenu = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesmenu.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getProyectos = async (oculto) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                oculto: oculto
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};



export const postProyecto = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postProyecto.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getOpcionesProyectos = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesProyectos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getOpcionesEditProyectos = async () => {
    // try {
    //     const response = await axios.get(baseUrl + 'opcionesProyectos.php?', {
    //         params: { token: getCookie('PHPSESSID') },
    //     });

    //     if (response.data.success) {
    //         // Procesar la respuesta y actualizar las opciones si es necesario
    //         return response.data;
    //     } else {
    //         console.log('Error');
    //         return null;
    //     }
    // } catch (error) {
    //     console.error('Error al verificar el token:', error);
    //     return null;
    // }
}


export const getProyecto = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getInfoProyecto = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};



export const getTareas = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro, limit, page, empleadosFiltro, clientesFiltro, searchTerm, tiposDeTarea) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareastest.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro,
                limit: limit,
                page: page,
                empleados: empleadosFiltro,
                clientes: clientesFiltro,
                searchTerm: searchTerm,
                tiposDeTarea: tiposDeTarea
            },
        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};
export const getTodasTareas = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro, limit, page, proyectosFiltro, empleadosFiltro, clientesFiltro, searchTerm, tiposDeTarea) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'todastareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro,
                limit: limit,
                page: page,
                empleados: empleadosFiltro,
                clientes: clientesFiltro,
                proyectos: proyectosFiltro,
                searchTerm: searchTerm,
                tiposDeTarea: tiposDeTarea

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const eliminarTarea = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'deleteTarea.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }

}
export const getTarea = async (id, id_tarea, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'tareas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                id_tarea: id_tarea,
                tipo: tipo
            },
        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postTarea = async (data, archivos) => {
    console.log(data);

    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postTarea.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};



export const postSA = async (data, archivos) => {
    try {
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postSA.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }

}
export const getTareaSA = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro, limit, page, proyectosFiltro, empleadosFiltro, clientesFiltro, searchTerm) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareasSA.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro,
                limit: limit,
                page: page,
                empleados: empleadosFiltro,
                clientes: clientesFiltro,
                proyectos: proyectosFiltro,
                searchTerm: searchTerm

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getInfoTareaSA = async (id_tarea) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareasSA.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id_tarea: id_tarea,
                id: 0,

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};
export const getEstados = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'estados.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//ticket
export const getTickets = async (id, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'tickets.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const postTickets = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postTicket.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//trabajadores
export const getTrabajadores = async (idProyecto) => {

    let id = idProyecto ?? 0;

    try {
        const response = await axios.get(baseUrl + 'trabajadores.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                idProyecto: id,
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const getOpcionesTickets = async (id, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestickets.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
//acltualizar tarea
export const actualizarTarea = async (data) => {
    console.log(data); //trabajadores esta vacio

    try {
        const response = await axios.put(baseUrl + 'actualizarTarea.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//acltualizar proyectos
export const updateProyecto = async (data) => {

    try {
        const response = await axios.put(baseUrl + 'proyectos.php?', {
            token: getCookie('PHPSESSID'),
            data: data,
            _t: Date.now() // ← esto evita la caché del navegador
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getPrueba = async () => {
    try {
        const response = await axios.get('http://93.189.90.30/test', {

        });

        if (response) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response;
        } else {
            console.log('Error s');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}


//post
//tareas
//comentarios

export const postComentarioTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTareas.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postComentarioTareaInter = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTareasInterno.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


//opciones tareas
export const getOpcionesTareas = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

//opciones form crear tareas
export const getOpcionesCrearTareas = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionescreartareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
//update tareas

export const updateTarea = async (tarea) => {
    try {
        const response = await axios.get(baseUrl + 'tareas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: tarea
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//tiempo Tareas

//iniciar
export const inicioTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'tiempoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//clientes

export const getClientes = async () => {
    try {
        const response = await axios.get(baseUrl + 'clientes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getClientesAgora = async () => {
    try {
        const response = await axios.get(baseUrl + 'clientesAgora.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//fichajes
export const inicioFichaje = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'fichajes.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getFichaje = async (fecha) => {
    try {
        const response = await axios.get(baseUrl + 'fichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fecha: fecha
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const finFichaje = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'fichajes.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getTodosFichajes = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.get(baseUrl + 'allfichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fechaDesde,
                fechaHasta,
                usuarios
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTodosFichajesDescarga = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesdescarga.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};
export const getFichajesUsuario = async (mes, year, id) => {
    try {
        const response = await axios.get(baseUrl + 'fichajeUsuario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                mes: mes,
                year: year,
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//recursos humanos
export const getOpcionesRrhh = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesrrhh.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//usuarios
export const getUsuarios = async () => {
    try {
        const response = await axios.get(baseUrl + 'usuarios.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getUsuariosCliente = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'usuarios.php?', {
            params: { token: getCookie('PHPSESSID'), id: id },

        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}


export const postUsuario = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'usuario.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const postCliente = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'clientesPost.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const updateCliente = async (idCliente, acceso) => {
    try {
        const response = await axios.put(baseUrl + 'clientes.php?', {
            token: getCookie('PHPSESSID'),
            idCliente: idCliente,
            acceso: acceso

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const postClienteAgora = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'clientesPostAgora.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const delUsuario = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'usuario.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }

}
export const actualizarUsuario = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'usuario.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//administrador
export const getOpcionesAdmin = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesAdministrador.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

//roles y permisos
export const getRolesYDepartamentos = async () => {
    try {
        const response = await axios.get(baseUrl + 'rolesydepartamentos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
export const getEmpleadosProyectos = async () => {
    try {
        const response = await axios.get(baseUrl + 'empleadosProyectos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const actualizarRolesYDepartamentos = async (data, option, rolid) => {
    try {
        const response = await axios.put(baseUrl + 'rolesydepartamentos.php??', {
            token: getCookie('PHPSESSID'),
            option: option,
            rolid: rolid,
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const actualizarEmpleadosProyectos = async (empleado) => {

    console.log(empleado);

    try {
        const response = await axios.put(baseUrl + 'empleadosProyectos.php??', {
            token: getCookie('PHPSESSID'),
            data: empleado

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//crear ticket
export const getDataCrearTicket = async () => {
    try {
        const response = await axios.get(baseUrl + 'dataCrearTIcket.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

///////////taller//////////////

export const getTaller = async (tipo, fechaDesde, fechaHasta, estadosFiltroStr) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'taller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFiltroStr
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getExtras = async (idTarea) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'extras.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                idTarea: idTarea
            },
        });
        console.log(response);


        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const deleteExtra = async (id, idTarea) => {
    try {
        const response = await axios.post(baseUrl + 'extras.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id,
                idTarea: idTarea
            }

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }

}

export const postTareaTaller = async (data, archivos) => {
    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postTareaTaller.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};

export const getOpcionesTareasTaller = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestareasTaller.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
export const getEstadosTaller = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'estadosTaller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const actualizarTareaTaller = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'actualizarTareaTaller.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTareaTaller = async (id_tarea) => {
    try {
        const response = await axios.get(baseUrl + 'taller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id_tarea: id_tarea,
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const postComentarioTaller = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTaller.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getSeguimientoTaller = async (token) => {
    try {
        const response = await axios.get(baseUrl + 'seguimientoTaller.php?', {
            params: { token: token },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getTareasCalendario = async (token) => {
    try {
        const response = await axios.get(baseUrl + 'tareasCalendario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getJornadas = async () => {
    try {
        const response = await axios.get(baseUrl + 'jornadas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getTodosFichajesAuditoria = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesauditoria.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};

export const putTiempoTrabajadoTarea = async (data, id_tarea) => {
    console.log(data);

    try {
        const response = await axios.put(baseUrl + 'actualizarTiempotrabajadoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data,
            id_tarea: id_tarea

        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getVersion = async (versionLocal) => {


    try {
        const response = await axios.get(baseUrl + 'controlVersion.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                versionLocal: versionLocal
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTodasTareasInfoUnica = async (searchTerm) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'todastareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: null,
                tipo: 1,
                fechaDesde: "2000-01-29",
                fechaHasta: "2105-01-29",
                estados: "0,1,2,3,4",
                limit: 100,
                page: 1,
                empleados: null,
                clientes: null,
                proyectos: null,
                searchTerm: searchTerm

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const postTipoTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'tipoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}
export const editTipoTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'editTipoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}

export const deleteTipoTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'deleteTipoTarea.php?', {
            token: getCookie('PHPSESSID'),
            id: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}

export const postCorregirFichaje = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'corregirFichaje.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const fichajeTotem = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'fichajetotem.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const updateAnularFichaje = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'anularFichaje.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}
export const getFichajesPendientes = async () => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'fichajesPendientes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};
export const updateFichajePendiente = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'fichajesPendientes.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}